var map = {
	"./AgentAssist/logo.png": 70095,
	"./agentassistlogin/logo.png": 95013,
	"./bcx/logo.png": 38485,
	"./blueoak/logo.png": 78316,
	"./default/logo.png": 14142,
	"./eskom/logo.png": 55249,
	"./momentum/logo.png": 92731,
	"./tigerbrands/logo.png": 29635,
	"./tongaat/logo.png": 95172,
	"./xib-demo/logo.png": 12960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54123;